import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Edit3, Save } from 'react-feather';
import { projectSelectors } from 'store/slices/projectsSlice';

const Editable = ({
    text,
    type,
    placeholder,
    children,
    childRef,
    onSave,
    error,
    ...props
}) => {
    const [isEditing, setEditing] = useState(false);
    const project = useSelector(projectSelectors.getCurrentProject);
    const hasRights =
        project.user_role === 'MAINTAINER' || project.user_role === 'OWNER';

    useEffect(() => {
        if (childRef && isEditing === true) {
            if (type === 'editor') {
                childRef.focus();
            } else if (childRef.current) {
                childRef.current.focus();
            }
        }
        if (error) {
            setEditing(true);
        }
    }, [isEditing, childRef, type, error]);

    const handleKeyDown = (event, type) => {
        const { key } = event;
        const keys = ['Escape', 'Tab'];
        const enterKey = 'Enter';
        const allKeys = [...keys, enterKey];
        if (
            (type === 'editor' && keys.indexOf(key) > -1) ||
            (type !== 'editor' && allKeys.indexOf(key) > -1)
        ) {
            setEditing(false);
            onSave();
        }
    };

    const save = () => {
        onSave();
        setEditing(false);
    };

    const onBlur = (e) => {
        if (e.relatedTarget) {
            return;
        }
        save();
    };

    return (
        <section {...props}>
            {isEditing ? (
                <div
                    style={{ flex: 1 }}
                    onBlur={onBlur}
                    onKeyDown={(e) => handleKeyDown(e, type)}
                >
                    {children}
                </div>
            ) : (
                <div>{text || placeholder || 'Editable content'}</div>
            )}
            {hasRights && (
                <>
                    {isEditing ? (
                        <Save
                            onClick={save}
                            className={`cursor-pointer ${
                                type === 'editor' && 'icon-sticky'
                            }`}
                            color="#007BFF"
                            size={20}
                            style={{ minWidth: '20px', marginLeft: '8px' }}
                        />
                    ) : (
                        <Edit3
                            onClick={() => setEditing(true)}
                            className={`cursor-pointer ${
                                type === 'editor' && 'icon-sticky'
                            }`}
                            color="#007BFF"
                            size={20}
                            style={{ minWidth: '20px', marginLeft: '8px' }}
                        />
                    )}
                </>
            )}
        </section>
    );
};

export default Editable;
